import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Whakamōhio mai mō tēnei whārangi',
  title: 'Whakamōhio mai i tētahi raruraru o tēnei whārangi',
  reasons: {
    'inaccurate-or-fabricated': 'He mōhiohio hē, he mōhiohio tito rānei',
    'wrong-product': 'Kāore ngā hua e hāngai ki te whārangi',
    'sexually-explicit': 'He ihirangi moepuku mārakerake',
    'regulated-product': 'He hua mā te whakahau rongoā, he hua e herea ana e te ture rānei',
    'dangerous-product': 'He hua mōrearea',
    'ip-infringement': 'Ka takahi i ōku mana (tohu tauhokohoko/manatārua)',
    other: 'Tētahi atu mea',
  },
  detail: 'Ngā taipitopito (kōwhiri noa)',
  submit: 'Tukuna te pūrongo',
  cancel: 'Whakakore',
  sent: 'Ngā mihi. Ka arotakea e mātou ngā pūrongo i roto i ngā hāora 24.',
  failed: 'Kāore i taea te tuku i te pūrongo. Tēnā, whakamātau anō.',
};
